import s from './SliderProductsSkeleton.module.css'
import ProductSkeleton from '../ProductSkeleton/ProductSkeleton'

interface SliderProductsSkeletonProps {
  title: string
  itemCount?: number
}

export default function SliderProductsSkeleton({
  title,
  itemCount = 3,
}: SliderProductsSkeletonProps) {
  return (
    <div className={s.sliderProducts}>
      <div className={s.heroSlider}>
        <h2>{title}</h2>
        <div className={s.buttonSkeleton}></div>
      </div>
      <div className={s.sliderContainer}>
        {Array.from({ length: itemCount }).map((_, index) => (
          <div key={index} className={s.slide}>
            <ProductSkeleton />
          </div>
        ))}
      </div>
      <div className={s.navigationWrap}>
        <div className={s.navButton}></div>
        <div className={s.navButton}></div>
      </div>
    </div>
  )
}
